export const getTgWebApp = () =>
  typeof window === "undefined" ? undefined : window.Telegram?.WebApp
export const getTgUser = () => getTgWebApp()?.initDataUnsafe?.user
export const getTgUserId = (): number | undefined => getTgUser()?.id
export const getTgInitData = (): string => getTgWebApp()?.initData ?? ""

const UNKNOWN_VERSION_FLOOR = "6.0"
const FULLSCREEN_MIN_VERSION = "8.0"
const SWIPE_BEHAVIOUR_MIN_VERSION = "7.7"
const FULLSCREEN_PLATFORM_MARKERS = ["android", "ios"]

/**
 * Segments compare as numbers, so "7.10" outranks "7.7". Gate every
 * version-limited WebApp method with this: the SDK throws on an older client.
 */
export const versionAtLeast = (
  current: string | undefined,
  target: string
): boolean => {
  const left = ((current ?? "").trim() || UNKNOWN_VERSION_FLOOR).split(".")
  const right = target.trim().split(".")

  for (let i = 0; i < Math.max(left.length, right.length); i++) {
    const a = parseInt(left[i] ?? "") || 0
    const b = parseInt(right[i] ?? "") || 0

    if (a === b) continue
    return a > b
  }

  return true
}

export const supportsSwipeBehaviour = (version: string | undefined): boolean =>
  versionAtLeast(version, SWIPE_BEHAVIOUR_MIN_VERSION)

/**
 * Markers, not exact names: Telegram X reports "android_x". False on desktop
 * and web clients, which answer the request with UNSUPPORTED.
 */
export const supportsFullscreen = (
  platform: string | undefined,
  version: string | undefined
): boolean => {
  const name = (platform ?? "").toLowerCase()

  return (
    FULLSCREEN_PLATFORM_MARKERS.some((marker) => name.includes(marker)) &&
    versionAtLeast(version, FULLSCREEN_MIN_VERSION)
  )
}
